export default "/images/a51738829b4b9431fac1e84f24ebdc49.avif";